/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { addslashes, elementHasClassName, htmlspecialchars, split_once, str_trim } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';
import { MDTimezones } from './timezone.js';

import { MDLocale } from './locale-impl.js';
import { convertToSelect2WithDefaultFit } from './select2.js';


export let MVLog = function($,mj) {

	// TODO: remove all fixed element IDs from this view.... ("#log-filter-user_id" etc...)

	let cfg_url_logs_get;
	let cfg_url_logs_filter_data;
	let cfg_search_users;

	let users_by_id = {};
	let log_batch_offset = 0;
	const log_batch_count = 50;
	let log_action_texts = null;
	let log_entity_type_names = null;

	let log_filter_changed_in_progress_count = 0;

	function _lln( rurl, lbl ) {
		return '<a href="'+mj.uwn+'/'+htmlspecialchars(rurl,true,true)+'" target="_blank">'+lbl+'</a>';
	}
	function log_media_link( media_id ) {
		return _lln( 'media#search='+encodeURIComponent('$3 "'+media_id+'"'), media_id );
	}
	function log_category_link( cat_id ) {
		return _lln( 'media#category='+encodeURIComponent(cat_id), cat_id );
	}
	function log_media_list_link( mid_arr, txt ) {
		return _lln( 'media#search='+encodeURIComponent('$3 '+mid_arr.map( (e) => '"'+e+'"' ).join(' | ')), txt );
	}
	function log_user_link( user_id ) {
		return _lln( 'administration/user_groups#user_id='+encodeURIComponent(user_id), user_id );
	}
	function log_username_link( login ) {
		return _lln( 'administration/user_groups#login='+encodeURIComponent(login), htmlspecialchars(login) );
	}
	function log_usergroup_link( group_id ) {
		return _lln( 'administration/user_groups#group_id='+encodeURIComponent(group_id), group_id );
	}

	function log_meta_group_link( mgroup_id ) {
		return _lln( 'administration/metadata#mgroup_id='+encodeURIComponent(mgroup_id), mgroup_id );
	}
	function log_meta_def_link( meta_id ) {
		return _lln( 'administration/metadata#meta_id='+encodeURIComponent(meta_id), meta_id );
	}

	function log_entity_html( entity_type, entity ) {
		switch( entity_type ) {
		case  1: // ALET_MEDIA
			return log_media_link(entity);
		case  5: // ALET_CATEGORY
			return log_category_link(entity);
		case  6: // ALET_USER_GROUP
			return log_usergroup_link(entity);
		case  7: // ALET_USER
			return log_user_link(entity);
		case 14: // ALET_META_GROUP
			return log_meta_group_link(entity);
		case 15: // ALET_META_DEFINITION
			return log_meta_def_link(entity);
		// case  9: // ALET_ACL
		// case 12: // ALET_DOWNLOAD_FORMAT
		// case 13: // ALET_PREVIEW_FORMAT
		// case 16: // ALET_EXPORT_CHANNEL
		// TODO
		}
		return htmlspecialchars(entity);
	}

	function log_get_userinfo( user_id ) {
		return users_by_id[user_id] || { user_id:user_id, login:'', 'display-name':'-', type:'r' };
	}
	function log_get_user_title_str( uinfo, alt_user_name ) {
		if( uinfo.login ) alt_user_name = uinfo.login;
		return 'ID: '+uinfo.user_id+', '+(uinfo['display-name']!=='-'?uinfo['display-name']:alt_user_name);
	}

	function log_details_click( evt ) {
		const td = $(this);
		const tr = td.parent('tr');
		td.off('click');

		const keep_open = ( evt.ctrlKey || evt.metaKey || evt.shiftKey );
		if( !keep_open ) {
			// close details of other rows
			tr.siblings('.log_details')
				.removeClass('log_details')
				.each( function() {
					const other_td = $(this).children('.log-details');
					other_td
						.text(other_td.data('details-kstr'))
						.addClass('xlink').attr('tabindex','0')
						.removeClass('open')
						.click(log_details_click);
				} );
		}

		// show details
		td.empty()
			.removeClass('xlink').removeAttr('tabindex')
			.addClass('open');
		const table = $('<table />').addClass('log-detail-tab');
		const vars_arr = td.data('details');
		const vars_arr_len = vars_arr.length;
		for( let idx=0; idx<vars_arr_len; ++idx ) {
			const va = vars_arr[idx];
			const k = va[0];
			const v = va[1];
			const row = $('<tr />').appendTo(table);
			const eoc = (idx%2)==0 ? 'even' : 'odd';
			$('<td />')
				.addClass('key '+eoc)
				.text(k)
				.appendTo(row);
			const td_v = $('<td />')
				.addClass('value '+eoc)
				.appendTo(row);
			if( k==='media_id' ) {
				if( v.length ) td_v.html( log_media_link(v) );
			} else if( k==='media_ids' ) {
				// media list
				const v_arr = v.split(', ');
				if( v_arr.length == 1 ) {
					td_v.html( log_media_link(v_arr[0]) );
				} else if( v_arr.length > 1 ) {
					let tmp_html = [];
					for( let i=0; i<v_arr.length; ++i ) tmp_html.push( log_media_link(v_arr[i]) );
					td_v.html( tmp_html.join(', ') + ' &nbsp; <i>' + log_media_list_link(v_arr,mjt('log-media-list-search-files').replace('%1',v_arr.length)) + '</i>' );
				}
			} else if( k==='group_id' ) {
				if( v.length ) td_v.html( log_usergroup_link(v) );
			} else if( k==='groups' ) {
				// group list
				const v_arr = v.split(', ');
				let tmp_html = [];
				for( let i=0; i<v_arr.length; ++i ) tmp_html.push( log_usergroup_link(v_arr[i]) );
				td_v.html( tmp_html.join(', ') );
			} else if( k==='user_id' || k==='by_user' || k==='impersonate_source_user_id' ) {
				if( v.length ) td_v.html( log_user_link(v) );
			} else if( k==='user_ids' ) {
				const v_arr = v.split(', ');
				if( v_arr.length == 1 ) {
					td_v.html( log_user_link(v_arr[0]) );
				} else if( v_arr.length > 1 ) {
					let tmp_html = [];
					for( let i=0; i<v_arr.length; ++i ) tmp_html.push( log_user_link(v_arr[i]) );
					td_v.html( tmp_html.join(', ') );
				}
			} else if( k==='login' || k==='impersonate_source_username' ) {
				if( v.length ) td_v.html( log_username_link(v) );
			} else if( k==='xfdf' ) {
				td_v.css('white-space','pre-wrap').text(v);
			} else if( k==='payload' || k==='download_size' || k==='archive_size' ) {
				td_v.text( MDLocale.fmt_filesize(v,true)+' ('+v+'b)' );
			} else if( k==='lifetime' ) {
				td_v.text( MDLocale.fmt_duration_fancy(v,true,4)+' ('+v+'s)' );
			} else {
				// plain text
				td_v.text(v);
			}
		}
		table.appendTo(td);
		tr.addClass('log_details');

		$('<span class="link different" tabindex="0">'+mjt('close')+'</span>')
			.click(function() {
				const tr = $(this).closest('tr');
				const td = tr.children('.log-details');
				tr.removeClass('log_details');
				td.text(td.data('details-kstr'))
					.addClass('xlink').attr('tabindex','0')
					.removeClass('open')
					.click(log_details_click);
				return false;
			})
			.appendTo(td);
	}

	function log_process_details( tr, td, details ) {
		// parse details
		const lines = details.split('\n');
		const lines_len = lines.length;
		let vars_arr = [];
		let vars_obj = {};
		for( let i=0; i<lines_len; ++i ) {
			const tmp = split_once(lines[i],'=');
			if( tmp.length==2 ) {
				const k = tmp[0];
				let v = tmp[1];
				// unquote
				const v1 = v.substr(1,v.length-2).split('');
				const v1len = v1.length;
				v = [];
				for( let si=0; si<v1len; ++si ) {
					const c1 = v1[si];
					if( c1==='\\' ) {
						si++;
						const c2 = v1[si];
						if( c2==='"' ) {
							v.push('"');
						} else if( c2==='n' ) {
							v.push('\n');
						} else if( c2==='r' ) {
							v.push('\r');
						} else if( c2==='t' ) {
							v.push('\t');
						} else if( c2==='\\' ) {
							v.push('\\');
						} else {
							v.push('\\'); v.push(c2);
						}
					} else {
						v.push(c1);
					}
				}
				v = v.join('');
				// pre-process some known list values
				if( k==='media_ids' || k==='groups' || k==='user_ids' ) {
					v = v.split(',').join(', ');
				} else if( k==='filenames' ) {
					v = v.split(':').join(': ');
				}
				vars_arr.push([k,v]);
				vars_obj[k] = v;
			}
		}

		let dt_idx = lines_len==1 ? details.length : details.indexOf( String.fromCharCode(10) ); // first newline
		if( dt_idx == -1 && details.length > 40 ) dt_idx = 40; // hard cut after some chars
		if( dt_idx == -1 ) {
			td.text(details);
		} else {
			let k_arr = [];
			const vars_arr_len = vars_arr.length;
			for( let i=0; i<vars_arr_len; ++i ) k_arr.push( vars_arr[i][0] );
			const k_str = k_arr.join(', ');
			if( k_str.length > 0 ) {
				let emph_details = [];

				if( vars_obj.hasOwnProperty('fulltext') ) emph_details.push( 'fulltext=' + vars_obj['fulltext'] );
				if( vars_obj.hasOwnProperty('text_result_count') ) emph_details.push( 'text_result_count=' + vars_obj['text_result_count'] );
				if( vars_obj.hasOwnProperty('result_count') ) emph_details.push( 'result_count=' + vars_obj['result_count'] );
				if( vars_obj.hasOwnProperty('work_count') ) emph_details.push( 'work_count=' + vars_obj['work_count'] );

				if( vars_obj.hasOwnProperty('version') ) emph_details.push( 'version=' + vars_obj['version'] );
				if( vars_obj.hasOwnProperty('version_comment') && vars_obj['version_comment']!=='' ) emph_details.push( 'version_comment=' + vars_obj['version_comment'] );

				if( vars_obj.hasOwnProperty('login') ) emph_details.push( 'login=' + vars_obj['login'] );
				if( vars_obj.hasOwnProperty('first_name') && vars_obj['first_name']!=='' ) emph_details.push( 'first_name=' + vars_obj['first_name'] );
				if( vars_obj.hasOwnProperty('last_name') && vars_obj['last_name']!=='' ) emph_details.push( 'last_name=' + vars_obj['last_name'] );
				if( vars_obj.hasOwnProperty('email') && vars_obj['email']!=='' ) emph_details.push( 'email=' + vars_obj['email'] );

				if( vars_obj.hasOwnProperty('title') ) emph_details.push( 'title=' + vars_obj['title'] );
				if( vars_obj.hasOwnProperty('name') ) emph_details.push( 'name=' + vars_obj['name'] );

				if( vars_obj.hasOwnProperty('filename') ) emph_details.push( 'filename=' + vars_obj['filename'] );
				if( vars_obj.hasOwnProperty('media_filename') ) emph_details.push( 'media_filename=' + vars_obj['media_filename'] );

				if( vars_obj.hasOwnProperty('payload') ) emph_details.push( 'payload=' + MDLocale.fmt_filesize(vars_obj['payload'],true) );
				if( vars_obj.hasOwnProperty('download_size') ) emph_details.push( 'download_size=' + MDLocale.fmt_filesize(vars_obj['download_size'],true) );
				if( vars_obj.hasOwnProperty('archive_size') ) emph_details.push( 'archive_size=' + MDLocale.fmt_filesize(vars_obj['archive_size'],true) );

				const details_str = emph_details.join(', ') + ( emph_details.length ? ', …' : k_str+', …' );
				td.data( { details: vars_arr, 'details-kstr': details_str } )
					.text(details_str)
					.addClass('xlink').attr('tabindex','0')
					.click(log_details_click);
			} else {
				td.data( { details: vars_arr, 'details-kstr': '' } );
			}
		}
	}

	function log_show_entries( offset, ondone ) {
		startProgress(true);
		$('.log_nav_prev').off('click').removeClass( 'log_nav_active' ).addClass( 'log_nav_disabled disabled' );
		$('.log_nav_next').off('click').removeClass( 'log_nav_active' ).addClass( 'log_nav_disabled disabled' );

		let flt_user_type = '';
		let flt_user_id = $('#log-filter-user_id').val();
		if( flt_user_id==='r' ) {
			flt_user_id = '';
			flt_user_type = 'r';
		} else if( flt_user_id==='s' ) {
			flt_user_id = '';
			flt_user_type = 's';
		}

		const typed_action = $('#log-filter-form input.lf-eta:checked').val();
		const tap = typed_action.split(':');
		const flt_entity_type = tap.length==2 ? tap[0] : '';
		const flt_entity_id = $('#log-filter-entity_id').val();
		const flt_action = tap.length==2 ? tap[1] : '';

		let flt_fulltext_pattern = str_trim( $('#log-filter-fulltext-pattern').val() );
		if( flt_fulltext_pattern==='*' ) flt_fulltext_pattern = '';

		$('#log-filter-fulltext-on-users-result').html('');
		const fulltext_on_users = $('#log-filter-fulltext-on-users:checked').val()==='1';

		const flt_date_val = $('#log-filter-date-value').val();


		const get_and_show_entries = function _get_and_show_entries( search_string ) {
			const postdata = {
				'offset': offset,
				'count': log_batch_count,
				'tz': MDTimezones.getTimezoneName(),
				'log_filter[fulltext_pattern]': search_string,
				'log_filter[date]': flt_date_val,
				'log_filter[client_id]': $('#log-filter-client_id').val()||'',
				//'log_filter[username]': $('#log-filter-username').val(),
				'log_filter[user_type]': flt_user_type,
				'log_filter[user_id]': flt_user_id,
				'log_filter[entity_type]': flt_entity_type,
				'log_filter[entity_id]': flt_entity_id,
				'log_filter[action]': flt_action,
			};
			$.postJSON( cfg_url_logs_get, $.param(postdata), function _logs_get_result_cb(j) {
				$('#log tr[id^=le_],#log tr[id^=ld_]').remove();
				$('#page-right-container').scrollTop(0);
				const le_tmpl = $('#log_entry_template');
				const ld_tmpl = $('#log_day_template');
				let prev_day = '';
				const jlen = j.length;
				for( let idx=0; idx<jlen; ++idx ) {
					// Zeit 	Benutzer 	Session 	Aktion 	Objekt 	Details
					const e = j[idx];
					const et = parseInt(e.entity_type,10);
					const loc_ltime = e.ltime;
					const day = loc_ltime.substr(0,10);
					if( day != prev_day ) {
						ld_tmpl.clone()
							.attr('id','ld_'+day)
							.insertBefore(le_tmpl)
							.children().text(MDLocale.fmt_date(day)).end()
							.show();
						prev_day = day;
					}
					const uinfo = log_get_userinfo(e.user_id);

					let username_title_str = log_get_user_title_str(uinfo,e.user_name);// 'ID: '+e.user_id+', '+(uinfo['display-name']!=='-'?uinfo['display-name']:e.user_name);
					if( e.impersonate_source_user_id!=0 ) {
						const impersonated_uinfo = log_get_userinfo(e.impersonate_source_user_id);
						username_title_str += '\n' + 'Impersonated by '+log_get_user_title_str(impersonated_uinfo,'');
					}
					let session_title_str = e.session_id;
					if( e.impersonate_source_session_id!='' ) {
						session_title_str += '\n' + 'Impersonated from '+e.impersonate_source_session_id;
					}
					// console.log(e);

					const tr = le_tmpl
						.clone()
						.attr('id','le_'+idx)
						.insertBefore(le_tmpl);
					const td_list = tr.children();
					td_list.first().text( MDLocale.fmt_time_detailed(loc_ltime) ).attr( 'title', loc_ltime+' ('+MDTimezones.getTimezoneName()+')' )
						.next('td').text( e.client_id ).attr( 'title', e.client_id )
						.next('td').html( (e.impersonate_source_user_id!=0?'↑ ':'') + log_username_link(e.user_name) ).attr( 'title', username_title_str )
						.next('td').text( /*(e.impersonate_source_session_id!=''?'↑ ':'') +*/ (e.session_id===''?'':e.session_id.substr(0,8)+'…') ).attr( 'title', session_title_str )
						.next('td').text( log_action_texts[e.action] ).attr( 'title', e.action )
						.next('td').html( log_entity_html(et,e.entity) ).attr( 'title', log_entity_type_names[et] );
						// .next('td').empty();
					if( uinfo.type==='s' || e.impersonate_source_user_id!=0 ) tr.addClass('different');
					tr.show();

					// add details
					log_process_details( tr, td_list.filter('.log-details'), e.details );
				}
				log_batch_offset = offset;

				// update navigation
				if( log_batch_offset > 0 ) {
					$('.log_nav_prev')
						.removeClass( 'log_nav_disabled disabled' ).addClass( 'log_nav_active' )
						.click( function() {
							log_show_entries( log_batch_offset - log_batch_count );
						} );
				}
				if( j.length >= log_batch_count ) {
					$('.log_nav_next')
						.removeClass( 'log_nav_disabled disabled' ).addClass( 'log_nav_active' )
						.click( function() {
							log_show_entries( log_batch_offset + log_batch_count );
						} );
				}
				stopProgress();
			},
			false,
			function _logs_get_result_complete_cb( jqXHR, textStatus ) {
				if( ondone ) ondone();
			} );
		}; // function _get_and_show_entries()

		if( fulltext_on_users && flt_fulltext_pattern.length>1 ) {
			// eventually resolve user login names from search terms..
			cfg_search_users(flt_fulltext_pattern,function( search_string, matching_logins_arr ) {
				if( matching_logins_arr && matching_logins_arr.length ) {
					let resulting_search_string = '('+search_string+')';

					// show matched users in side panel:
					let html = '<ul>';
					const max_matches = 50;
					for( let u=0; u<matching_logins_arr.length && u<max_matches; ++u ) {
						const user = matching_logins_arr[u];
						html += '<li class="link" mj_user_id="'+user.user_id+'" title="'+htmlspecialchars(user.login,true,true)+'">' + htmlspecialchars(user['display-name'],false,true) + '</li>';
						resulting_search_string += '|"'+addslashes(user.login)+'"';
					}
					html += '</ul>';
					$('#log-filter-fulltext-on-users-result').html(html);

					get_and_show_entries(resulting_search_string);
				} else {
					get_and_show_entries(search_string);

				}
			} );
		} else {
			get_and_show_entries(flt_fulltext_pattern);
		}

	}

	function log_filter_changed() {
		log_filter_changed_in_progress_count ++;
		log_show_entries(0);
	}

	return {

		init: function( module, action_texts, entity_type_names ) {

			cfg_url_logs_get = 'json/'+module+'/logs-get';
			cfg_url_logs_filter_data = 'json/'+module+'/logs-filter_data';

			if( module==='administration' ) {
				cfg_search_users = function( search_string, on_finished ) {
					const postdata = 'search_string='+encodeURIComponent(search_string);
					$.postJSON('json/administration/user_groups-user_search', postdata, function(j) {
						on_finished(search_string,j);
					} );
				};
			} else {
				cfg_search_users = function( search_string, on_finished ) {
					on_finished(search_string,[]);
				};
			}

			log_action_texts = action_texts;
			log_entity_type_names = entity_type_names;

			// init form values (values may not be empty on page reload)
			$('#log-filter-date,#log-filter-date-value,#log-filter-client_id,#log-filter-user_id,#log-filter-entity_id').val('');
			$('#log-filter-typed_action--1').prop('checked',true);

			// add filter event handlers
			$('#log-filter-date').datepicker( {
				altField:'#log-filter-date-value',
				altFormat:'yy-mm-dd',
				onSelect: function() {
					$('#log-filter-date-reset').css('visibility','visible');
					log_filter_changed();
				},
			} ).change( function(evt) {
				const disp_v = $(this).val();
				const intr_v = MDLocale.xtr_date(disp_v);
				if( intr_v==='' ) $(this).val('');
				$('#log-filter-date-value').val(intr_v);
				$('#log-filter-date-reset').css('visibility',intr_v===''?'hidden':'visible');
				log_filter_changed();
			} );
			$('#log-filter-date-reset').click( function() {
				$('#log-filter-date,#log-filter-date-value').val('');
				$(this).css('visibility','hidden');
				log_filter_changed();
			} );
			$('#log-filter-form input.lf-eta').click(function() {
				if( elementHasClassName(this,'lf-etg') ) {
					const id = $(this).attr('id');
					$('#log-filter-form div.log-filter-typed_action-group').hide();
					$('#log-filter-entity_id').val('');
					$('#'+id+'-actions').show();
				}
				log_filter_changed();
			});
			$('#log-filter-fulltext-on-users').click(function() {
				if( $('#log-filter-fulltext-on-users').prop('checked') ) {
					$('#log-filter-user_id').val('').trigger('change.select2');
				}
				log_filter_changed();
			} );
			$('#log-filter-fulltext-on-users-result').on('click','li',function(e) {
				const mj_user_id = $(this).attr('mj_user_id');
				$('#log-filter-fulltext-on-users').prop('checked',false);
				$('#log-filter-fulltext-pattern').val('*');
				$('#log-filter-user_id').val(mj_user_id).trigger('change.select2');
				log_filter_changed();
				// console.log([mj_user_id,e]);
			} );

			// $('#log-filter-entity_id'.change( function(evt) {
			// 	const disp_v = $(this).val();
			// 	log_filter_changed();
			// } );

			$('#log-filter-form').submit( function(e) {
				log_filter_changed();
				e.preventDefault();
				return false;
			} );


			const tmp_count = log_filter_changed_in_progress_count;

			// get additional data for filters
			startProgress(false);
			$.postJSON( cfg_url_logs_filter_data, '', function _filter_data_result_cb(j) {
				stopProgress();
				if( j.hasOwnProperty('users') ) {
					// user list
					let opts_regular = [
						{ id: 'r', text: mjt('log-filter-user_id-all-r','!') },
					];
					let opts_system = [
						{ id: 's', text: mjt('log-filter-user_id-all-s','!') },
					];
					const tmp_userlist_len = j.users.length;
					for( let i=0; i<tmp_userlist_len; ++i ) {
						const u = j.users[i];
						users_by_id[u.user_id] = u;
						const opt = { id: u.user_id, text: u['display-name'] };
						if( u.type==='s' ) opts_system.push(opt);
						else opts_regular.push(opt);
					}
					const userlist_opts = [
						{ id: '', text: mjt('log-filter-user_id-all','!') },
						{ text: mjt('log-filter-user_id-r','!'), children: opts_regular },
						{ text: mjt('log-filter-user_id-s','!'), children: opts_system },
					];
					convertToSelect2WithDefaultFit( $('#log-filter-user_id'), true, { data: userlist_opts } )
						.change(log_filter_changed);
				}
				// client list
				let clientlist_opts = [
					{ id: '', text: mjt('log-filter-client_id-all','!') },
				];
				const cll = j.clients.length;
				for( let i=0; i<cll; ++i ) {
					const cl = j.clients[i];
					clientlist_opts.push( { id: cl.client_id, text: cl.title } );
				}
				convertToSelect2WithDefaultFit( $('#log-filter-client_id'), true, { data: clientlist_opts } )
					.change(log_filter_changed);

				if( log_filter_changed_in_progress_count <= tmp_count ) {
					// load log entries..
					log_filter_changed();
				}
			}, true );


			// handle location hash change events
			$(document).on( 'mjshashchange', function(e,k,v) {
				if( k==='entity_id' ) {
					$('#log-filter-entity_id').val(v);
					$('#log-filter-form').trigger('submit');
				} else if( k==='entity' ) {
					const eti = split_once(v,':');
					$('#log-filter-typed_action-et'+eti[0]).prop('checked',true);
					$('#log-filter-entity_id').val(eti[1]);
					$('#log-filter-form').trigger('submit');
				}
			} );

		},
	};

}(jQuery,mj); // namespace MVLog
